import type { SettingsType } from '../schemas'
import { ContainerWidth } from './width'

export const DEFAULT_SETTINGS: SettingsType = {
  maxWidth: ContainerWidth.Default,
  backgroundColor: null,
  contentBackgroundColor: null,
  linkColor: '#0000FF',
  textFontSize: 14,
  textColor: '#000000',
}
